import { Fragment, useContext, useEffect, useState } from "react";
import UserIcon from "../icons/UserIcon";
import { AppContext } from "../App";
import functions from "../functions/functions";
import moment from "moment/moment";
import "moment/locale/it";
import api from "./api/api";
import EditIcon from "../icons/EditIcon";
import AdvanceIcon from "../icons/AdvanceIcon";
import CheckIcon from "../icons/CheckIcon";
import WaiterIcon from "../icons/WaiterIcon";
import SplitIcon from "../icons/SplitIcon";
import PrinterIcon from "../icons/PrinterIcon";
import MoveIcon from "../icons/MoveIcon";
import QrIcon from "../icons/QrIcon";
import BillIcon from "../icons/BillIcon";
import { useAppStore } from "../store/useAppStore";
moment.locale("it");

function SidebarContent() {
    const {
        apiSettings,
        setConfirm,
        setLoading,
        init_cart,
        openOrder,
        updateOrder,
        setTablesListVisible,
        orders,
        table,
        setOpenTablePopupVisible,
        setTablePopup,
        setSearchAddressTerm,
        setQrPopupVisible,
        setActiveFlow,
        refreshOrdersState,
    } = useContext(AppContext);
    const [tableOrders, setTableOrders] = useState([]);
    const [selectedRomanaOrders, setSelectedRomanaOrders] = useState([]);
    const { setSplittedOrders, setSplittedOrdersCount } = useAppStore();

    useEffect(() => {
        if (table) {
            loadTableOrders();
        }
    }, [table, orders]);

    const mergeOrders = async (id) => {
        console.log("mergeOrders");
        setLoading(true);
        const res = await api.postProtected("/tables/merge_orders/" + id + "/", {});
        setLoading(false);
        if (res.success == 0) alert(res.error);
        else await refreshOrdersState();
    };

    const mergeRomanaOrders = async () => {
        console.log("mergeOrders");
        setLoading(true);
        const res = await api.postProtected("/orders/merge/", { ids: selectedRomanaOrders });
        setSelectedRomanaOrders([]);
        setLoading(false);
        if (res.success == 0) alert(res.error);
        else await refreshOrdersState();
    };

    const reOpen = async (id) => {
        console.log("reOpen");
        const res = await api.postProtected("/tables/edit/" + id + "/", { status: 1, disable_reset: 1 });
        if (res.success == 0) {
            alert(res.error);
            return;
        }
        await refreshOrdersState();
        init_cart();
    };

    const closeTable = async (id) => {
        console.log("closeTable");
        setLoading(true);
        const res = await api.postProtected("/tables/edit/" + id + "/", { status: 0 });
        setLoading(false);
        if (res.success == 0) {
            alert(res.error);
            return;
        }
        await refreshOrdersState();
        setTablePopup(false);
    };

    const fillAll = async (id) => {
        console.log("fillAll");
        setLoading(true);
        const res = await api.postProtected("/tables/fill_orders/" + id + "/");
        setLoading(false);
        if (res.success == 0) alert(res.error);
        else await refreshOrdersState();
    };

    const loadTableOrders = async () => {
        console.log("loadTableOrders");
        if (!table?.id) {
            setTableOrders([]);
            return;
        }

        const res = await api.postProtected("/pos2/table_orders/", {
            table_id: table.id,
        });
        if (res.success == 0) {
            alert(res.error);
            setTableOrders([]);
            return;
        }

        setTableOrders(Array.isArray(res.rows) ? res.rows : []);
    };

    const handleNewOrder = async () => {
        if (table.status == 0) {
            setTablePopup(false);
            setOpenTablePopupVisible(true);
        } else {
            init_cart({
                list_id: table.list_id,
                table: table,
                room_id: table.room_id,
                delivery_type: {
                    id: "shop",
                    name: "Sala",
                },
                delivery_date: null,
                address: false,
                delivery_time_range: null,
                self_cart_id: table.cart_id,
            });
            setTablesListVisible(false);
            setTablePopup(false);
            setSearchAddressTerm("");
            setActiveFlow(parseInt(table.flow) + 1);
        }
    };

    const advanceFlow = async (table) => {
        console.log("advanceFlow");
        setLoading(true);
        const res = await api.getProtected("/tables/advance_flow/" + table.id + "/");
        setLoading(false);
        if (res.success == 0) alert(res.error);
    };

    const showSelectedRomanaMerge = selectedRomanaOrders.length > 1;
    const showTableMerge = table?.single_order_mode == 0 && tableOrders.length > 1 && table?.status != 0;
    const showSingleOrderFooterActions = table?.status != 2 && table?.status != 0 && tableOrders.length == 1;
    const showCancelPrebill = apiSettings.mandant.fiscal_printers == 1 && table?.status == 2;
    const showCloseTable = apiSettings.orders.tables_open_by_filled != 1 && table?.status != 0;
    const showFillAll =
        apiSettings.orders.tables_open_by_filled == 1 &&
        apiSettings.mandant.fiscal_printers == 0 &&
        tableOrders.length > 0;
    const mergeButtonsCount = (showSelectedRomanaMerge ? 1 : 0) + (showTableMerge ? 1 : 0);
    const useMergeCloseFooterLayout =
        mergeButtonsCount == 1 &&
        showCloseTable &&
        !showSingleOrderFooterActions &&
        !showCancelPrebill &&
        !showFillAll;

    return (
        <div className="sidebar">
            {table && (
                <>
                    <div className="sidebar-header">
                        <div>
                            <div>{table.name}</div>
                            {table.status != 0 && <div>{functions.formatter.format(table.orders_total)}</div>}
                        </div>
                        {table.status != 0 && (
                            <div className="buttons-group centered">
                                {table.status != 2 && (
                                    <button className="button button-3 header-new-order-button" onClick={handleNewOrder}>
                                        Nuovo ordine
                                    </button>
                                )}
                                {table.single_order_mode == 0 &&
                                parseInt(table.flow) < parseInt(table.total_flows) && (
                                    <button
                                        title="Avanza portata"
                                        className="button button-1 icon square"
                                        onClick={() =>
                                            setConfirm({
                                                title: "Sei sicuro?",
                                                message:
                                                    "Procedo con l'avanzamento a Portata " +
                                                    (parseInt(table.flow) + 1),
                                                onConfirm: () => advanceFlow(table),
                                            })
                                        }
                                    >
                                        <AdvanceIcon />
                                    </button>
                                )}
                                <div className="qr-button">
                                    <button
                                        className="btn btn-secondary btn-square btn-icon"
                                        onClick={() => setQrPopupVisible(true)}
                                    >
                                        <QrIcon />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="sidebar-content">
                        {table.status == 0 ? (
                            <div className="sidebar-empty-state">
                                <div className="sidebar-empty-state-text">Tavolo chiuso</div>
                                <button className="button button-3" onClick={handleNewOrder}>
                                    Apri tavolo
                                </button>
                            </div>
                        ) : (
                            <SidebarOrders
                                orders={tableOrders}
                                selectedRomanaOrders={selectedRomanaOrders}
                                setSelectedRomanaOrders={setSelectedRomanaOrders}
                                showPayOrderButton={tableOrders.length > 1}
                            />
                        )}
                    </div>
                    <div className={"sidebar-footer" + (useMergeCloseFooterLayout ? " merge-close-footer-layout" : "")}>
                        {showSelectedRomanaMerge && (
                            <button
                                className="button button-3 merge-orders-button"
                                onClick={() => {
                                    setConfirm({
                                        title: "Sei sicuro?",
                                        message: "",
                                        onConfirm: () => mergeRomanaOrders(),
                                    });
                                }}
                            >
                                Unisci ordini ({selectedRomanaOrders.length})
                            </button>
                        )}
                        {showTableMerge && (
                            <button
                                className="button button-3 merge-orders-button"
                                onClick={() => {
                                    setConfirm({
                                        title: "Sei sicuro?",
                                        message: "",
                                        onConfirm: () => mergeOrders(table.id),
                                    });
                                }}
                            >
                                Unisci ordini
                            </button>
                        )}
                        {table.status != 2 && table.status != 0 && (
                            <>
                                {tableOrders.length == 1 && (
                                    <div className="single-order-footer-actions">
                                        <button
                                            className="button button-3 prebill-single-order-button"
                                            onClick={() =>
                                                updateOrder(tableOrders[0], {
                                                    prebill_request: 1,
                                                    prebill_printed: 0,
                                                })
                                            }
                                        >
                                            <PrinterIcon />
                                            Preconto
                                        </button>
                                        <button
                                            className="button button-1 pay-close-table-button"
                                            onClick={() => {
                                                openOrder(tableOrders[0]);
                                                setTablePopup(false);
                                                setSplittedOrders([]);
                                                setSplittedOrdersCount(0);
                                                setTablesListVisible(false);
                                            }}
                                        >
                                            <BillIcon />
                                            Paga e chiudi il tavolo
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                        {apiSettings.mandant.fiscal_printers == 1 && (
                            <>
                                {showCancelPrebill && (
                                    <button
                                        className="button button-3 cancel-prebill-button"
                                        onClick={() => {
                                            setConfirm({
                                                title: "Sei sicuro?",
                                                message: "Procedo con la riapertura di " + table.name,
                                                onConfirm: () => reOpen(table.id),
                                            });
                                        }}
                                    >
                                        Annulla preconto
                                    </button>
                                )}
                            </>
                        )}
                        {showCloseTable && (
                            <button
                                className="button button-3 close-table-button"
                                onClick={() => {
                                    setConfirm({
                                        title: "Sei sicuro?",
                                        onConfirm: () => closeTable(table.id),
                                    });
                                }}
                            >
                                Chiudi tavolo
                            </button>
                        )}
                        {showFillAll && (
                            <button
                                className="button button-3"
                                onClick={() => {
                                    setConfirm({
                                        title: "Sei sicuro?",
                                        message: "Verranno completati tutti gli ordini del " + table.name,
                                        onConfirm: () => fillAll(table.id),
                                    });
                                }}
                            >
                                Completa tutti
                            </button>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

function SidebarOrders({ orders, selectedRomanaOrders, setSelectedRomanaOrders, showPayOrderButton = false }) {
    const { apiSettings } = useContext(AppContext);
    const flowsEnabled = Number(
        apiSettings?.orders?.enable_flow ?? apiSettings?.orders?.enable_flows ?? 1
    ) === 1;

    return (
        <div className="sidebar-orders">
            {orders.map((order, i) => (
                <Fragment key={i}>
                    <Order
                        order={order}
                        move={!order.childs.length > 0}
                        split={!order.childs.length > 0}
                        complete={!order.childs.length > 0}
                        edit={!order.childs.length > 0}
                        pay={showPayOrderButton && !order.childs.length > 0}
                        flowsEnabled={flowsEnabled}
                    />
                    {order.childs
                        .filter((s) => s.bill == 0 || s.bill == null)
                        .map((suborder, i) => (
                            <Order
                                order={suborder}
                                key={i}
                                prebill={false}
                                move={false}
                                split={false}
                                complete={false}
                                checkbox={true}
                                selectedRomanaOrders={selectedRomanaOrders}
                                setSelectedRomanaOrders={setSelectedRomanaOrders}
                            />
                        ))}
                </Fragment>
            ))}
        </div>
    );
}

function Order({
    order,
    prebill = true,
    move = true,
    split = true,
    complete = true,
    edit = true,
    pay = false,
    flowsEnabled = true,
    checkbox = false,
    selectedRomanaOrders,
    setSelectedRomanaOrders,
}) {
    const {
        apiSettings,
        setConfirm,
        updateOrder,
        openOrder,
        setTablesListVisible,
        setSplitPopup,
        setTablePopup,
        setTableSelectorVisible,
    } = useContext(AppContext);
    const { setSplittedOrders, setSplittedOrdersCount } = useAppStore();

    function group_by_flow(products) {
        const flows = [];
        for (let index = 1; index <= 5; index++) {
            const flow = {
                id: index,
                products: [],
            };
            for (const product of products) {
                if (product.flow == index) flow.products.push(product);
            }
            flows.push(flow);
        }
        return flows;
    }

    function handleChange(e) {
        const checked = e.target.checked;

        setSelectedRomanaOrders((prev) => {
            if (checked) {
                // evita duplicati
                return prev.includes(order.id) ? prev : [...prev, order.id];
            } else {
                return prev.filter((id) => id !== order.id);
            }
        });
    }

    return (
        <div className="order">
            <div className="order-header">
                <div className="order-info">
                    <div className="order-info-row">
                        <span className="order-id">ID:{order.id}</span>
                        <span className="order-number">N:{order.number}</span>
                    </div>
                    <div className="order-list-name">Listino: {order.list_id ? order.list.name : "base"}</div>
                </div>

                <div className="horizzontal-group">
                    {checkbox && (
                        <>
                            <label htmlFor={"merge-" + order.id}>Unisci</label>
                            <input
                                type="checkbox"
                                id={"merge-" + order.id}
                                checked={selectedRomanaOrders.includes(order.id)}
                                onChange={handleChange}
                            />
                        </>
                    )}
                    {prebill && (
                        <button
                            title="Preconto"
                            className="button button-1 icon square"
                            onClick={() =>
                                updateOrder(order, {
                                    prebill_request: 1,
                                    prebill_printed: 0,
                                })
                            }
                        >
                            <PrinterIcon />
                        </button>
                    )}
                    {move && (
                        <button
                            title="Sposta Tavolo"
                            className="button button-1 icon square"
                            onClick={() => setTableSelectorVisible(order)}
                        >
                            <MoveIcon />
                        </button>
                    )}
                    {split && (
                        <button
                            title="Dividi ordine"
                            className="button button-1 icon square"
                            onClick={() => setSplitPopup({ mode: "list", order: order })}
                        >
                            <SplitIcon />
                        </button>
                    )}
                    {complete && apiSettings.mandant.fiscal_printers == 0 && (
                        <button
                            title="Completa"
                            className="button button-1 icon square"
                            onClick={() =>
                                setConfirm({
                                    title: "Evadi ordine ID " + order.number + "?",
                                    message: "Procedendo l'ordine non sarà più modificabile",
                                    onConfirm: async () => {
                                        await updateOrder(order, {
                                            bill: 1,
                                        });
                                    },
                                })
                            }
                        >
                            <CheckIcon />
                        </button>
                    )}
                    {edit && (
                        <button
                            title="Modifica"
                            className="button button-1 icon square"
                            onClick={() => {
                                openOrder(order);
                                setTablePopup(false);
                                setSplittedOrders([]);
                                setSplittedOrdersCount(0);
                                setTablesListVisible(false);
                            }}
                        >
                            <EditIcon />
                        </button>
                    )}
                    {pay && (
                        <button
                            className="button button-1 pay-order-button"
                            onClick={() => {
                                openOrder(order);
                                setTablePopup(false);
                                setSplittedOrders([]);
                                setSplittedOrdersCount(0);
                                setTablesListVisible(false);
                            }}
                        >
                            <BillIcon />
                            Paga
                        </button>
                    )}
                </div>
            </div>
            <div>
                {group_by_flow(order.products).map(
                    (flow, i) =>
                        flow.products.length > 0 && (
                            <div key={i}>
                                {flowsEnabled && (
                                    <div>
                                        <b>{"Portata " + (i + 1)}</b>
                                    </div>
                                )}
                                <div className="order-products">
                                    {flow.products.map((product, n) => (
                                        <div key={n}>
                                            <div>
                                                <Status status={product.status} />
                                                <span className="order-product-name">
                                                    {product.qty}x {product.name}
                                                </span>
                                                <ProductVariants product={product} />
                                            </div>
                                            <div>
                                                {functions.formatter.format(product.qty * product.price)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                )}
            </div>
            <div className="order-footer">
                <div>
                    {order.user && (
                        <div>
                            <WaiterIcon />
                            {order.user.name}
                        </div>
                    )}
                    {order.name && (
                        <div>
                            <UserIcon />
                            {order.name} {order.surname}
                        </div>
                    )}
                </div>
                <div>{functions.formatter.format(order.total)}</div>
            </div>
        </div>
    );
}

function ProductVariants({ product }) {
    const { menu } = useContext(AppContext);
    const hasVariantsCategories =
        Array.isArray(product.variants_categories) && product.variants_categories.length > 0;
    const reconstructedVariantsCategories = getReconstructedVariantsCategories(product, menu);

    if (reconstructedVariantsCategories.length > 0) {
        return (
            <div className="order-product-variants">
                {reconstructedVariantsCategories.map((variantsCategory, i) => (
                    <ProductVariantsCategory variantsCategory={variantsCategory} key={i} />
                ))}
                {product.ingredients?.map(
                    (ingredient, i) =>
                        ingredient.removed && (
                            <div key={"ingredient" + i} className="text-error">
                                No {ingredient.name}
                            </div>
                        )
                )}
            </div>
        );
    }

    if (hasVariantsCategories) {
        return (
            <div className="order-product-variants">
                {product.variants_categories.map((variantsCategory, i) => (
                    <ProductVariantsCategory variantsCategory={variantsCategory} key={i} />
                ))}
                {product.ingredients?.map(
                    (ingredient, i) =>
                        ingredient.removed && (
                            <div key={"ingredient" + i} className="text-error">
                                No {ingredient.name}
                            </div>
                        )
                )}
            </div>
        );
    }

    const variants = [];

    product.variants?.forEach((variant) => {
        if (variant.qty > 0) variants.push({ name: variant.name, qty: variant.qty });
    });
    product.products?.forEach((variant) => {
        if (variant.qty > 0) variants.push({ name: variant.name, qty: variant.qty });
    });

    if (variants.length === 0) return null;

    return (
        <div className="order-product-variants">
            {variants.map((variant, i) => (
                <span className="order-product-variant-item" key={i}>
                    {variant.qty}X {variant.name}
                </span>
            ))}
        </div>
    );
}

function getReconstructedVariantsCategories(product, menu) {
    const rawVariants = Array.isArray(product.variants) ? product.variants : [];
    const rawProducts = Array.isArray(product.products) ? product.products : [];
    if (rawVariants.length === 0 && rawProducts.length === 0) return [];

    const menuProduct = findMenuProduct(menu, product.product_id || product.id);
    if (!menuProduct?.variants_categories) return [];

    return menuProduct.variants_categories
        .map((variantsCategory) => {
            return {
                ...variantsCategory,
                variants: getSelectedVariants(variantsCategory, variantsCategory.variants, rawVariants, "variant_id"),
                variants2: getSelectedVariants(
                    variantsCategory,
                    variantsCategory.variants2,
                    rawVariants,
                    "variant_id"
                ),
                products: getSelectedVariants(variantsCategory, variantsCategory.products, rawProducts, "product_id"),
                products2: getSelectedVariants(variantsCategory, variantsCategory.products2, rawProducts, "product_id"),
            };
        })
        .filter((variantsCategory) => getVariantsCategoryVisibleItems(variantsCategory).length > 0);
}

function findMenuProduct(menu, productId) {
    for (const course of menu || []) {
        for (const category of course.categories || []) {
            for (const product of category.products || []) {
                if (product.id == productId) return product;
            }
        }
    }
    return null;
}

function getSelectedVariants(variantsCategory, menuItems = [], rawItems = [], idField) {
    return (menuItems || [])
        .map((menuItem) => {
            const rawItem = rawItems.find(
                (item) =>
                    item.variant_category_id == variantsCategory.id &&
                    item[idField] == menuItem.id
            );
            if (!rawItem) return null;

            return {
                ...menuItem,
                name: rawItem.name || menuItem.name,
                qty: rawItem.qty,
            };
        })
        .filter(Boolean);
}

function ProductVariantsCategory({ variantsCategory }) {
    const visibleItems = getVariantsCategoryVisibleItems(variantsCategory);
    if (visibleItems.length === 0) return null;

    return (
        <div className="order-product-variant-group">
            <div className="order-product-variant-category">{variantsCategory.name}</div>
            <div className="order-product-variant-items">
                {visibleItems.map((variant, i) => (
                    <span
                        className={"order-product-variant-item" + (variant.no ? " text-error" : "")}
                        key={i}
                    >
                        {variant.no ? "No " : variant.qty + "X "}
                        {variant.name}
                    </span>
                ))}
            </div>
        </div>
    );
}

function getVariantsCategoryVisibleItems(variantsCategory) {
    const visibleItems = [];

    variantsCategory.variants?.forEach((variant) => {
        if (variant.qty > 0) visibleItems.push({ ...variant, no: false });
    });
    variantsCategory.variants2?.forEach((variant) => {
        if (variant.qty == undefined) return;
        if (variant.qty > 0) {
            visibleItems.push({ ...variant, no: false });
            return;
        }
        if (variantsCategory.force_mono == 1 && variant.qty == 0)
            visibleItems.push({ ...variant, no: true });
    });
    variantsCategory.products?.forEach((variant) => {
        if (variant.qty > 0) visibleItems.push({ ...variant, no: false });
    });
    variantsCategory.products2?.forEach((variant) => {
        if (variant.qty > 0) visibleItems.push({ ...variant, no: false });
    });

    return visibleItems;
}

function Status({ status, width = 12, height = 12 }) {
    function getColor() {
        if (status == "preparation") return "var(--status2)";
        if (status == "ready") return "var(--status3)";
        if (status == "filled") return "var(--status4)";
        return "var(--status1)";
    }
    return (
        <div
            style={{
                width: width + "px",
                height: height + "px",
                backgroundColor: getColor(),
                display: "inline-block",
                marginRight: "5px",
            }}
        ></div>
    );
}

export default SidebarContent;
